import { useEffect, useState } from 'react';
import { useCookieConsent } from '../contexts/CookieConsentContext';
import Script from 'next/script';

const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID;

const GoogleAnalytics: React.FC = () => {
  const { hasConsent, preferences } = useCookieConsent();
  const [shouldLoadGA, setShouldLoadGA] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || !GA_MEASUREMENT_ID) {return;}
    
    const shouldEnableAnalytics = hasConsent && preferences.analytics;
    
    // Only load GA scripts after user has given consent
    if (shouldEnableAnalytics && !shouldLoadGA) {
      setShouldLoadGA(true);
    }
    
    // Update consent if GA is already loaded
    if (window.gtag && shouldLoadGA) {
      window.gtag('consent', 'update', {
        analytics_storage: shouldEnableAnalytics ? 'granted' : 'denied',
        ad_storage: 'denied',
        functionality_storage: 'granted',
        personalization_storage: 'denied',
        security_storage: 'granted',
      });
    }
  }, [hasConsent, preferences.analytics, shouldLoadGA]);

  // Don't render anything if no consent or no measurement ID
  if (!GA_MEASUREMENT_ID || !shouldLoadGA) {return null;}

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`}
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GA_MEASUREMENT_ID}', {
            page_title: document.title,
            page_location: window.location.href,
          });
          
          // Set consent to granted since we only load after consent
          gtag('consent', 'update', {
            analytics_storage: 'granted',
            ad_storage: 'denied',
            functionality_storage: 'granted',
            personalization_storage: 'denied',
            security_storage: 'granted',
          });
        `}
      </Script>
    </>
  );
};

export default GoogleAnalytics;
